import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isPreview: false,
  previewJwt: null
};
const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    previewStateCaptured: (state, action) => {
      state.isPreview = action.payload.isPreview;
      state.previewJwt = action.payload.previewJwt;
    }
  }
});
export const {
  previewStateCaptured
} = previewSlice.actions;
export default previewSlice.reducer;